import { useEffect, useState } from "react";
import "./PlayList.scss";
import PlayListTable from "./Components/DataList/playListTable";
import PlayListHeader from "./Components/playListHeader";
import AddEdit from "./Components/Add-Edit";
import { useDispatch, useSelector } from "react-redux";
import LoadingScreen from "./Components/loadingScreen";
import Notfound from "./Components/Notfound";
import { useLocation } from "react-router-dom";
import i18next from "i18next";
import { getModules } from "./Redux/actions";
import { getWithoutText } from "./Redux/features/PaginationSlice";
import { Loader } from "@empreinte/components.loader";
import Player from "./Components/Player";
import { setOffVideo } from "./Redux/features/PlayerVideo";
import { OnCancelAddEdit } from "./Redux/features/AddEditSlice";
import {GraphQLFetchDataPlaylist} from "./Utils/graphQLFetchData"
const PlayList = ({ submenu }) => {
	const { action } = useSelector((state) => ({
		...state.playlist,
	}));
	const { GlobalLoading, Authorized, desc, order } = useSelector((state) => ({
		...state.Pagination,
	}));
	const { AddingPlayList, EditingPlayList } = useSelector((state) => ({
		...state.addEdit,
	}));
	const { LoadingToWatch, watching, Videos } = useSelector((state) => ({
		...state.PlayerVideo,
	}));
	const [searchText, setSearchText] = useState("");
	   const [SearchWord, setSearchWord] = useState("");

	const { current } = useSelector((state) => ({ ...state.Pagination }));
	const [currentPage, setCurrentPage] = useState(current );

	const [pageSize, setPageSize] = useState(10);
	const [isLoading, setisLoading] = useState(true);
	const { search } = useLocation();
	const obj = new URLSearchParams(search);
	const dispatch = useDispatch();
	const {GetPlaylists} = GraphQLFetchDataPlaylist()
      const searchPlaylist = useSelector((state) => state.ReducerGetPodcastData.searchPlaylist);
	  const [pagination, setPagination] = useState(false);
	useEffect(() => {
		dispatch(getModules());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	useEffect(() => {
		if (Authorized) {
			if (searchPlaylist === "" || pagination === true) {
				const offset = (current - 1) * pageSize;
				getWithoutText();
				// dispatch(getPlayList({ params }));
				GetPlaylists({
					variables: {
						where: {
							titleContains: searchPlaylist,
						},
						pagination: {
							limit: pageSize,
							offset: offset,
						},
						orderBy: {
							direction: "DESC",
							field: "ID",
						},
					},
				}).finally((res) => {
					setisLoading(false);
				});
			}

		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPage, current, pageSize, action, Authorized, desc, order]);

	useEffect(() => {
		const lang = obj.get("lang");
		if (lang === "en" || lang === "fr") {
			i18next.changeLanguage(lang);
		}
		    window.addEventListener("message", function (event) {
					if (event.data?.info === "updateLang") {
						i18next.changeLanguage(event.data.lang);
						localStorage.setItem("lang", event.data.lang);
					}
					
				});
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [obj.get("lang")]);
	useEffect(() => {
		window.addEventListener("message", function (event) {
			if (event.data?.info === "redirectHomepage") {
				dispatch(OnCancelAddEdit());
			}
		});
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{GlobalLoading ? (
				<LoadingScreen />
			) : Authorized ? (
				<div className={"divGlobalTablePlayListe"}>
					{!AddingPlayList && !EditingPlayList ? (
						<div>
							<Loader isOpen={LoadingToWatch} />
							{watching ? (
								LoadingToWatch ? (
									""
								) : (
									<Player Videos={Videos} setOffVideo={setOffVideo} />
								)
							) : (
								<></>
							)}
							<PlayListHeader />
							{isLoading && !searchText ? (
								<Loader isOpen={isLoading} />
							) : (
								<PlayListTable
									SearchWord={SearchWord}
									setSearchWord={setSearchWord}
									setCurrentPage={setCurrentPage}
									currentPage={currentPage}
									setPageSize={setPageSize}
									pageSize={pageSize}
									setSearchText={setSearchText}
									searchText={searchText}
									setisLoading={setisLoading}
									Authorized={Authorized}
									setPagination={setPagination}
								/>
							)}
						</div>
					) : (
						<div>
							<form>
								<PlayListHeader />
								<AddEdit />
							</form>
						</div>
					)}
				</div>
			) : (
				<Notfound />
			)}
		</>
	);
};
export default PlayList;
